export default __webpack_public_path__ + "static/media/add.d56e66a2.svg";